import {StyleSheet, Platform} from 'react-native';
import {FONTS} from '../../utils/Constants';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.background,
      borderRadius: 16,
      height: '100%',
    },
    headerView: {
      marginTop: 30,
      marginHorizontal: 24,
    },
    scrollviewContainer: {
      paddingHorizontal: Platform.OS === 'web' ? 0 : 24,
      paddingBottom: 20,
    },
    title: {
      fontFamily: FONTS.boldFont,
      fontSize: 24,
      marginTop: 14,
      lineHeight: 36,
    },
    subtitle: {
      fontFamily: FONTS.regularFont,
      fontSize: 16,
      marginTop: 5,
      lineHeight: 24,
    },
    scrollView: {
      flex: 1,
      marginTop: 10,
    },
    fotgotPasswordText: {
      color: colors.link,
      fontFamily: FONTS.semiboldFont,
      fontSize: 14,
      textDecorationLine: 'underline',
      marginTop: 25,
    },
    signupText: {
      alignSelf: Platform.OS === 'web' ? 'left' : 'center',
      marginTop: 16,
      color: colors.textSecondary,
      fontSize: 14,
      fontFamily: FONTS.regularFont,
    },
    signupLinkText: {
      fontFamily: FONTS.semiboldFont,
      color: colors.link,
      textDecorationLine: 'underline',
      fontSize: 14,
    },
    button: {
      flex: 1,
    },
    alignLeft: {
      alignSelf: 'flex-start',
    },
    flex1Width292: {
      flex: 1,
      maxWidth: 292,
    },
  });

export default makeStyles;
